<template>
    <div :class="containerClass" @click="onWrapperClick">
        <template v-if="auth.isLoggedIn">
            <div class="layout-topbar">
                <div class="layout-toggle-menu">
                    <button class="layout-topbar-button" @click="onMenuToggle">
                        <i class="pi pi-bars"></i>
                    </button>
                </div>
                <router-link to="/" class="layout-topbar-logo flex-grow-none">
                    <img src="images/logo.png" alt="logo" class="my-5" width="164" height="52" />
                </router-link>
                <div class="layout-topbar-menu flex-grow-1 justify-content-end">
                    <template v-for="(item, index) of navbarTopLeftItems" :key="`navtopleftmenu-${index}`">
                        <router-link :to="item.to">
                            <Button :label="item.label" :icon="item.icon" class="p-button-text page-button" />
                        </router-link>
                    </template>
                    <NotificationBell />
                    <div class="topbar-user-btn" @click="toggleUserMenu($event)">
                        <Avatar shape="circle" icon="pi pi-user" class="topbar-user-avatar" />
                        <i class="pi pi-chevron-down topbar-chevron"></i>
                    </div>
                    <Menu ref="userMenuRef" :model="appBarActionMenu" :popup="true" />
                </div>
            </div>
                <div class="layout-sidebar" @click="onSidebarClick">
                    <div class="sidebar-user-header">
                        <router-link to="/account" class="sidebar-user-link">
                            <NiceImage class="sidebar-user-avatar" :src="$utils.setImgUrl(auth.userPhoto, 'medium')" />
                            <div class="sidebar-user-info">
                                <span class="sidebar-user-name">{{ auth.userName }}</span>
                                <span class="sidebar-user-role" v-if="auth.userRole">{{ auth.userRole }}</span>
                            </div>
                        </router-link>
                    </div>
                    <AppMenu :model="navbarSideLeftItems" @menuitem-click="onMenuItemClick" />
                </div>
                </template>
                <template v-else>
                    <!-- Floating transparent topbar for login -->
                    <div style="position: absolute; top: 0; left: 0; width: 100%; z-index: 1000; padding: 1rem 2rem;">
                        <router-link to="/">
                            <img src="images/logo.png" alt="logo" width="164" height="52" style="height: 40px; width: auto;" />
                        </router-link>
                    </div>
                    <!-- Full screen wrapper -->
                    <div style="min-height: 100vh; display: flex; flex-direction: column;">
                        <router-view :key="$route.fullPath" style="flex: 1;" />
                    </div>
                </template>
                
                <div v-if="auth.isLoggedIn" class="layout-main-container ">
                    <div class="layout-main">
                        <router-view :key="$route.fullPath" />
                        
                    </div>
                    <div class="layout-footer gap-3 flex justify-content-center align-items-center">
                        <div>
                            &copy; 2026 Proin & Zendata
                        </div>
                    </div>
                    
                </div>
                <!-- App right drawer -->
                <Sidebar :showCloseIcon="false" position="right" v-model:visible="rightDrawer.showDrawer" :style="{width: rightDrawer.width}">
                    <component v-if="rightDrawer.showDrawer" is-sub-page :is="drawerComponentFile" :api-path="rightDrawer.pageUrl" :page-data="rightDrawer.pageData" />
                </Sidebar>
                
                <transition name="layout-mask">
                    <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
                </transition>
                
                <!-- Page display dialog -->
                <Dialog class="card py-4 px-0" :breakpoints="{'960px': '50vw', '640px': '95vw'}" :style="{width: pageDialog.width, maxWidth: pageDialog.maxWidth}" :modal="!pageDialog.seamless" :maximized="pageDialog.maximized" :dismissableMask="!pageDialog.persistent" :position="pageDialog.position" v-model:visible="pageDialog.showDialog" :showHeader="false">
                    <Button v-if="pageDialog.closeBtn" @click="pageDialog.showDialog=false" style="position:absolute;right:0px;top:0px" icon="pi pi-times" class="p-button-rounded p-button-text p-button-plain" />
                    
                    <component  v-if="pageDialog.showDialog" is-sub-page :is="dialogComponentFile" :api-path="pageDialog.pageUrl" :page-data="pageDialog.pageData" />
                </Dialog>
                
                <!-- image preview dialog-->
                <Dialog class="card p-0" header="..." :showHeader="true" :breakpoints="{'960px': '40vw', '640px': '95vw'}" style="width:auto" v-model:visible="imageDialog.showDialog" dismissableMask modal>
                    <div class="text-center">
                        <Carousel v-if="imageDialog.images.length > 1" :value="imageDialog.images" :circular="false" :page="imageDialog.currentSlide">
                        <template #item="{data}">
                            <div class="text-center">
                                <NiceImage style="max-width:100%;max-height:70vh" :src="data" />
                            </div>
                        </template>
                        </Carousel>
                        <NiceImage v-else style="max-width:100%;max-height:70vh" :src="imageDialog.images[0]" />
                    </div>
                </Dialog>
                
                <!-- request error dialog -->
                <Dialog class="card p-0" modal  v-model:visible="errorDialog" :breakpoints="{'960px': '50vw', '640px': '95vw'}" style="width:30vw;" position="top">
                    <template #header>
                        <div class="flex align-items-center">
                            <div class="mr-2">
                                <Avatar size="large" class="bg-pink-100 text-pink-600" icon="pi pi-exclamation-triangle" />
                                </div>
                                <div class="flex text-lg text-pink-600 font-bold">
                                    No se ha podido acompletar la petición.
                                </div>
                            </div>
                        </template>
                        <div class="text-grey-500 font-bold text-lg" v-for="(msg, index) in pageErrors" :key="index">
                            {{msg}}
                        </div>
                    </Dialog>
                    
                    <!-- app confirm page dialog -->
                    <ConfirmDialog></ConfirmDialog>
                    
                    <!-- app flash message toast -->
                    <Toast position="top-center" />
                    
                    <!-- app fullscreen loading dialog -->
                    <Dialog class="card m-0" :showHeader="false" modal  v-model:visible="fullScreenLoading" :breakpoints="{'960px': '50vw', '640px': '95vw'}" style="width:20vw;" position="center">
                        <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>
                        <div class="mt-2 text-center text-500">{{ fullScreenLoadingMsg }}</div>
                    </Dialog>
                </div>
            
</template>
<script setup>
	import { defineAsyncComponent, ref, toRefs, computed, onMounted, onBeforeUnmount } from "vue";
	import AppMenu from 'src/components/AppMenu.vue';
	import NotificationBell from 'src/components/NotificationBell.vue';
	import { useApp } from 'src/composables/app';
	import { useAuth } from 'src/composables/auth';
	import { useRoute, useRouter } from 'vue-router';
	
	
	import { useAppStore } from 'src/store/app';
	import { useToast } from 'primevue/usetoast';

	const app = useApp();
	const auth = useAuth();
	const store = useAppStore();
	const toast = useToast();
	//const route = useRoute();
	//const router = useRouter();

	const { pageDialog, imageDialog, rightDrawer, pageErrors, fullScreenLoading, fullScreenLoadingMsg } = toRefs(store);
	const dialogComponentFile = computed(() => {
		if(pageDialog.value.showDialog && pageDialog.value.pageComponent){
			return defineAsyncComponent(() => import(`src/pages/${pageDialog.value.pageComponent}.vue`));
		}
		return null;
	});

	const drawerComponentFile = computed(() => {
		if(rightDrawer.value.showDrawer && rightDrawer.value.pageComponent){
			return defineAsyncComponent(() => import(`src/pages/${rightDrawer.value.pageComponent}.vue`));
		}
		return null;
	});

	const errorDialog = computed ({
		get() {
			return pageErrors.value.length > 0;
		},
		set(newValue) {
			pageErrors.value = [];
		}
	});
	const onSessionExpired = () => toast.add({ severity: 'warn', summary: 'Sesión vencida', detail: 'Vuelve a iniciar sesión.', life: 2500 });
	onMounted(() => window.addEventListener('erpz:session-expired', onSessionExpired));
	onBeforeUnmount(() => window.removeEventListener('erpz:session-expired', onSessionExpired));
	const userMenuRef = ref(null);
	function toggleUserMenu(event) {
		userMenuRef.value.toggle(event);
	}

	const layoutMode = ref('static');
	const menuClick = ref(false);
	const staticMenuInactive = ref(false);
	const overlayMenuActive = ref(false);
	const mobileMenuActive = ref(false);

	const containerClass = computed(() => {
		if(!auth.isLoggedIn){
			staticMenuInactive.value = true;
			mobileMenuActive.value = false;
		}

		return ['layout-wrapper', {
			'layout-overlay': layoutMode.value === 'overlay',
			'layout-static': layoutMode.value === 'static',
			'layout-static-sidebar-inactive': staticMenuInactive.value && layoutMode.value === 'static',
			'layout-overlay-sidebar-active': overlayMenuActive.value && layoutMode.value === 'overlay',
			'layout-mobile-sidebar-active': mobileMenuActive.value,
			'p-input-filled': false,
		}];
	});
	// Filtra el menú por permisos de forma recursiva. Un encabezado de grupo
	// (sin `to`, con `items`) se muestra SOLO si al menos uno de sus hijos es
	// visible; cada hijo se filtra por canView. Antes se usaba
	// `.filter(m => canView(m.to))`, que dejaba pasar los grupos (to === "" es
	// falsy → canView devuelve true) y nunca filtraba a los hijos.
	const filterMenuItems = (items) => (items || []).reduce((acc, item) => {
		if (item.items && item.items.length) {
			const children = filterMenuItems(item.items);
			if (children.length) {
				acc.push({ ...item, items: children });
			}
		} else if (auth.canView(item.to)) {
			acc.push(item);
		}
		return acc;
	}, []);
	const navbarSideLeftItems = filterMenuItems(app.menus.navbarSideLeft);
	const navbarTopLeftItems = filterMenuItems(app.menus.navbarTopLeft);
	const navbarTopRightItems = filterMenuItems(app.menus.navbarTopRight);
	function onMenuItemClick(event) {
		if (event.item && !event.item.items) {
			overlayMenuActive.value = false;
			mobileMenuActive.value = false;
		}
	}

	function onWrapperClick() {
		if (!menuClick.value) {
			overlayMenuActive.value = false;
			mobileMenuActive.value = false;
		}
		menuClick.value = false;
	}

	function onMenuToggle() {
		menuClick.value = true;
		if (app.isDesktop()) {
			if (layoutMode.value === 'overlay') {
				if(mobileMenuActive.value === true) {
					overlayMenuActive.value = true;
				}
				overlayMenuActive.value = !overlayMenuActive.value;
				mobileMenuActive.value = false;
			}
			else if (layoutMode.value === 'static') {
				staticMenuInactive.value = !staticMenuInactive.value;
			}
		}
		else {
			mobileMenuActive.value = !mobileMenuActive.value;
		}
	}
	const  appBarActionMenu = [
		{
			to: '/account',
			label: "Mi Cuenta",
			icon: 'pi pi-user',
		},
		{
			label: "Cerrar Sesión",
			icon: 'pi pi-window-minimize',
			command: (event) => {
				startLogout();
			},
		},
	];
	function startLogout() {
		auth.logout();
		location.href = "/"; //reload page and navigated to index page
	}

</script>
